import styled from "styled-components";
import NameIcon from "./img/account_circle.png"
import EmailIcon from "./img/mail.png"
import PasswordIcon from "./img/key.png"
import BirthIcon from "./img/celebration.png"
import GenIcon from "./img/wc.png"
import DoramChibiImg from "./img/doram_female_hair1_color1.gif"
import GlobalIcon from "./img/public.png"
import { TipMouseOutEvent, TipMouseOverEvent } from "../../../Tooltip/Tooltip";
import { MusicPlayFunction } from "../../../WavSoundEffects/WavSoundEffects";
import { ApiConnectEmailAvailable,  ApiConnectLionsUserAvailable,  ApiConnectLogRegister,  ApiConnectUserRegister} from "../../../api/LionsUserApiConect";
import { useForm } from "react-hook-form";
import PopUpWarning, { PopUpCaller } from "../../../PopUpWarning/PopUpWarning";
import GreenCheck from "./img/green-check.png"
import RedCheck from "./img/red-check.png"
import { useContext, useState } from "react";
import VisiblePassImg from "./img/visibility.png"
import HiddenPassImg from "./img/visibility_off.png"
import SanitizeInputFunction from "../../../Functions/SanitizeInputFunction";
import SanitizePasswordFunction from "../../../Functions/SanitizePasswordFunction";
import { PageContext } from "../../../Context/PageContext";
import EmailConfirmFormulary, { GenerateValidationCodeFunction } from "../../../EmailConfirmFormulary/EmailConfirmFormulary";
import PopMenuWindow, { OpenPopMenu } from "../../../PopMenuWindow/PopMenuWindow";
import SuccessNewAccount from "./SucessNewAccount";
import RegulamentDescript from "./RegulamentDescript";
import CloudFlareTurnstile from "../../../CloudFlareTurnstile/CloudFlareTurnstile";
import Dashboard from "../../Dashboard/Dashboard";


function NewAccountForm(){

    const dataAtual = new Date();
    const anoAtual = dataAtual.getFullYear();

    const { setRegisterPageSection, popMenuContent, setPopMenuContent, setPage} = useContext(PageContext);

    var visiblePassFieldTag = false;

    function VisiblePasswordFunction () {

        if(visiblePassFieldTag  === false){
            setVisiblePassword("text");
            setVisiblePasswordIcon(VisiblePassImg);
            visiblePassFieldTag  = true;
            return;
        } else {
            setVisiblePassword("password");
            setVisiblePasswordIcon(HiddenPassImg);
            visiblePassFieldTag  = false;
            return;
        }

    }

    function checkLoginField() {

        let sanitizedLogin = getValues('userName');

        if(sanitizedLogin.length === 0) {
            setLoginAvaliableCheck("");
            return false;
            }

        if(sanitizedLogin.length < 6) {
            setLoginAvaliableCheck(RedCheck); 
            return false;
            }
        

        //var resultLoginCheck = ApiConnectLionsUserAvailable(getValues('userName'));
        //        resultLoginCheck.then((response) => {
        //            if(response === false) {
        //                setLoginAvaliableCheck(GreenCheck);
        //                return true;
        //            } else { 
        //                setLoginAvaliableCheck(RedCheck);
        //                return false;
        //            }
        //        })
        //        .catch((error) => error)

        setLoginAvaliableCheck(GreenCheck);
        return true;
    }


    function EmailFieldAvailable (){

        let email = getValues('userEmail');

        if(email.length === 0) { 
            setEmailAvaliableCheck("");
            return false;
        }

        if(!email.includes("@") || email.length <=12) { 
            setEmailAvaliableCheck(RedCheck);
            return false;
        }

        setEmailAvaliableCheck(GreenCheck);
        return true;

    }


    function checkPasswordField () {

        var passContentField = getValues('userPassword')

        if(passContentField.length < 10 ) {
            setValidPasswordIcon("")
            return false;
        }

        const regexMaiuscula = /["A-Z"]/;
        const regexMinuscula = /[a-z]/;
        const regexNumero = /[0-9]/;
        const regexCaractereEspecial = /[!@#$&*]/;
        
        const temMaiuscula = regexMaiuscula.test(passContentField);
        const temMinuscula = regexMinuscula.test(passContentField);
        const temNumero = regexNumero.test(passContentField);
        const temCaractereEspecial = regexCaractereEspecial.test(passContentField);

        if(temMaiuscula === false || temMinuscula === false || temNumero === false || temCaractereEspecial === false) {
            setValidPasswordIcon(RedCheck)
            return false;
        };

        setValidPasswordIcon(GreenCheck)
        return true;
    }


    function confirmationPassword () {

        let passConfirmation = getValues('pass_confirmation')

        if(passConfirmation.length === 0) {
            setValidConfirmPasswordIcon("");
            return false;
        }

        if(getValues('userPassword') !== passConfirmation || passConfirmation.length < 4) {
            setValidConfirmPasswordIcon(RedCheck);
            return false;
        }
        setValidConfirmPasswordIcon(GreenCheck);
        return true;
    }


    const { register, getValues} = useForm();

    const [emailAvaliableCheck, setEmailAvaliableCheck] = useState();
    const [loginAvaliableCheck, setLoginAvaliableCheck] = useState();
    const [visiblePassword, setVisiblePassword] = useState("password");
    const [visiblePasswordIcon, setVisiblePasswordIcon] = useState(HiddenPassImg);
    const [validPasswordIcon, setValidPasswordIcon] = useState("");
    const [validConfirmPasswordIcon, setValidConfirmPasswordIcon] = useState("");
    const [submitButtonColor, setSubmitButtonColor] = useState("rgba(112, 118, 113, 0.5)");
    const [cloudflareFeedback, setCloudflareFeedback] = useState(false);
    const [releaseRuleForm, setReleaseRuleForm] = useState(<></>);

    const [availableSubmit, setAvailableSubmit] = useState("none");


    function fieldsValidation(){

        if(checkLoginField() === false || EmailFieldAvailable() === false || checkPasswordField() === false || confirmationPassword() === false || getValues('birthDate') === "" || getValues('gender') === "" || getValues('rulesAcceptance') === false) {
            setSubmitButtonColor("rgba(112, 118, 113, 0.5)");
            setAvailableSubmit("none");
            return;

        } 
        if(parseInt(anoAtual) - parseInt(getValues('birthDate').split('-')[0]) < 18 || parseInt(anoAtual) - parseInt(getValues('birthDate').split('-')[0]) > 120) {
            var negado = "Você precisar ter entre 18 e 120 anos para se cadastrar em nosso servidor. ";
            setSubmitButtonColor("rgba(112, 118, 113, 0.5)");
            setAvailableSubmit("none");
            PopUpCaller(negado,"rgba(191, 18, 18, 0.8)", 10000);
            return;

        } if(!cloudflareFeedback) {
            return;

        } else {
            setSubmitButtonColor("rgba(25, 171, 49, 1)");
            setAvailableSubmit("auto");
        }

    }        
        
        function registerRequest(){

            var negado = "Cadastro Negado! Alguma coisa deu errado com seus dados!"
            var autorizado = "Cadastro Realizado com Sucesso. já pode se logar no menu Conta e criar seus acessos ao servidor!"

            let result = ApiConnectUserRegister(getValues()).
            then((response) => {
                if(response.data === false) {
                    PopUpCaller(negado,"rgba(191, 18, 18, 0.8)", 10000);
                    return;
                } else {
                    ApiConnectLogRegister(getValues('userName'), "Se juntou a família LionsRagnarok em : ");
                    setPopMenuContent(<SuccessNewAccount/>);
                    setTimeout(() => {
                        setPage(<Dashboard />)  
                    }, 3000);
                    return;
                }
            });

        }
        
        function CloudFlareChalenge() {
            setCloudflareFeedback(true);
            setReleaseRuleForm(
                <CheckBoxContainer>
                    <InputRulesForm type="checkbox"
                    {...register('rulesAcceptance', {
                        onChange: (e) => {
                            if(e.target.checked) {
                                setPopMenuContent(<RegulamentDescript/>);
                                OpenPopMenu();
                                fieldsValidation();
                            }
                        }
                    })}/>
                    <SpanRules> Li e estou de acordo com todas as regras e condições de acesso e permanencia no servidor.</SpanRules>
                </CheckBoxContainer> 
            )
        }

    return(
        <Fieldset id="novocadastro">
            <Legend>
                <h1>Criação de Contas</h1>
                <PopUpWarning />
            </Legend>

	        <FormRegister>

                <ColumnMaster>
                    <ColumnA>

                        <ColumnItemContainer>
	                        <ColumItemHeader>
                                <ColumItemHeaderIcon iconImg={NameIcon}/>
                                <ColumItemHeaderName>Nome</ColumItemHeaderName>
                                <FieldAvaliableCheck checkImg={loginAvaliableCheck}/>
                            </ColumItemHeader> 

                            <Input
                            type="text"
                            size="30" 
                            pattern=".{4,23}"
                            {...register("userName", {
                                onChange: (e) => {
                                    e.target.value = SanitizeInputFunction(e.target.value);
                                    fieldsValidation();}
                                    })}
                            required 
                            placeholder=" minimo 4 digitos"
                            />

                        </ColumnItemContainer>

                       

                        <ColumnItemContainer
                        onMouseOver={(event) => TipMouseOverEvent(event, 
                            "Palavra-Passe precisa conter:<br><br>" +
                            "Letra Maiúscula;" +
                            "<br>Letra Minúscula;" +
                            "<br>Caractere Numérico;" +
                            "<br>Caractere especial (!@#$&*);",
                             "rgb(39, 106, 168)")}
                        onMouseLeave={() => TipMouseOutEvent() }>
                            <ColumItemHeader>
                                <ColumItemHeaderIcon iconImg={PasswordIcon}/>
                                <ColumItemHeaderName>Senha</ColumItemHeaderName>
                                <ColumItemVisiblePasswordIcon
                                iconImg={visiblePasswordIcon}
                                onClick={() => VisiblePasswordFunction()}/>
                                <FieldAvaliableCheck checkImg={validPasswordIcon}/>
                            </ColumItemHeader> 

                            <Input
                            type={visiblePassword}
                            size="32"
                            {...register("userPassword", {
                                onChange: (e) => {
                                    e.target.value = SanitizePasswordFunction(e.target.value);
                                    fieldsValidation();}
                            })}
                            pattern=".{10,32}"
                            placeholder=" Mínimo de 10 digitos"
                            required />

                        </ColumnItemContainer>

                        <ColumnItemContainer>
                            <ColumItemHeader>
                                <ColumItemHeaderIcon iconImg={PasswordIcon}/>
                                <ColumItemHeaderName>Confirme a senha</ColumItemHeaderName>
                                <FieldAvaliableCheck checkImg={validConfirmPasswordIcon}/>
                            </ColumItemHeader>

	                        <Input
                            type={visiblePassword}
                            size="32"
                            pattern=".{10,32}"
                            placeholder="Confirme a Senha"
                            {...register('pass_confirmation', {
                                onChange: (event) => {
                                    event.target.value = SanitizePasswordFunction(event.target.value);
                                    fieldsValidation();
                                    }})
                            }
                            required
                            />

                        </ColumnItemContainer>
                    </ColumnA>
        
                    <ColumnB>
                     <ColumnItemContainer>
                            <ColumItemHeader>
                                <ColumItemHeaderIcon iconImg={EmailIcon}/>
                                <ColumItemHeaderName>Email</ColumItemHeaderName>
                                <FieldAvaliableCheck checkImg={emailAvaliableCheck}/>
                            </ColumItemHeader> 

                            <Input
                            type="email"
                            size="30"
                            {...register("userEmail", {
                                    onChange: () => { fieldsValidation();}})
                                }
                            required
                            placeholder=" Email para contato"
                            />

                        </ColumnItemContainer>

                        

                        <ColumnItemContainer>
                            <ColumItemHeader>
                                <ColumItemHeaderIcon iconImg={BirthIcon}/>
                                <ColumItemHeaderName>Data de Nascimento</ColumItemHeaderName>
                            </ColumItemHeader>

                            <Input
                            type="date"
                            {...register("birthDate", {
                                    onChange: () => { fieldsValidation();}})
                                }
                            required/>

                        </ColumnItemContainer>

                        <ColumnItemContainer>
                            <ColumItemHeader>
                                <ColumItemHeaderIcon iconImg={GenIcon}/>
                                <ColumItemHeaderName>Gênero</ColumItemHeaderName>
                            </ColumItemHeader>

                            <Select width={"230px"}
                                {...register("sex", {
                                    onChange: () => { fieldsValidation();}})
                                }
                                id="sexo"
                                 required>
                                <option value="" disabled selected>Escolha uma Opção</option>
                                <option value="M" name="sexo" id="sexo">Masculino</option>
                                <option value="F" name="sexo" id="sexo">Fêminino</option>
                            </Select>

                        </ColumnItemContainer>

                    </ColumnB>
                </ColumnMaster>

                <CloudFlareTurnstile desiredFunction={CloudFlareChalenge}/>

                <CheckBoxContainer>
                    <InputRulesForm type="checkbox"
                    {...register('rulesAcceptance', {
                        onChange: (e) => {
                            if(e.target.checked) {
                                setPopMenuContent(<RegulamentDescript/>);
                                OpenPopMenu();
                            }
                            fieldsValidation();
                        }
                    })}/>
                    <SpanRules> Li e estou de acordo com todas as regras e condições de acesso e permanencia no servidor.</SpanRules>
                </CheckBoxContainer>  

                <ServerSelectContainer>

	                <ServerSelectHeader>
                        <ServerSelectIcon iconImg={GlobalIcon}/>
                        <ServerSelectName>SERVIDOR</ServerSelectName>
                    </ServerSelectHeader>

                    <Select width={"100%"} >
                        <option value="1" name="_serverselcet" id="_tserverselect" selected>Hrist - Episódeo 19 - Terras Geladas de Issgard</option>
	                    <option value="2" name="_serverselcet" id="_tserverselect" disabled>Lenneth - Old Times - Transclasses  (Em  construção)</option>
	                </Select>
        
	                <T1> Ao cliclar em <b>"Concordo"</b> você afirma estar de acordo com todas as regras e regulamentos do servidor. </T1>
	                <ConfirmInput
                    color={submitButtonColor}
                    onClick={() => {
                            GenerateValidationCodeFunction(getValues('userName'), getValues('userEmail'),"codeToEmail");
                            setPopMenuContent(
                                    <EmailConfirmFormulary
                                        ActionFunction={registerRequest}
                                        userMail={getValues('userEmail')}>
                                    </EmailConfirmFormulary>);
                            OpenPopMenu();
                            }
                        }
                    value="Concordo - Concluir meu cadastro"
                    available={availableSubmit}
                    />

	                <ClearInput  type="reset" value="Limpar Campos" />
                </ServerSelectContainer>
	        </FormRegister>

	    </Fieldset>

    );
}

export default NewAccountForm;

const Fieldset = styled.fieldset`
    margin: 0px 0;
    display: flex;
    flex-direction: column;
    border: solid 1px rgba(0,0,0,.5);
    width: 100%;
    width: 700px;
    border-radius: 10px;
    padding: 0px 30px;

    //box-shadow: 10px 10px 10px 0px rgba(0,0,0,0.5);
    @media (max-width: 1000px) {
    width: 100%;
    scale: .8;
    }

`
const Legend = styled.legend`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 40px 0;
    padding: 0;
    background-color: white;
    height: 50px;
    width: 400px;
    //border: solid;
`

const FormRegister = styled.form`
    display: flex;
    flex-direction: column;
    align-items: center;
    //width: 550px;
    margin: 0px;
    //border: solid 2px black;

    @media (max-width: 1000px) {
    width: 90vw;
    }
`

const ColumnMaster = styled.div`
    display: flex;
    //flex-direction: column;
    justify-content: center;
    width: 100%;
    margin-top: 0px;
    //border: solid 2px black;

    @media (max-width: 1000px) {
    flex-direction: column;
    }
    
`
const ColumnA = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    margin-right: 10px;
    //border: solid 2px black;
    text-align: center;
    `

const ColumnB = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    //border: solid 2px black;
    text-align: center;
`

const ColumnItemContainer = styled.div`
    display: flex;
    flex-direction: column;
    //width: 550px;
    //border: solid 2px black;
    margin: 10px 0;
    padding: 10px 0;
    justify-content: center;
    align-items: center;
    transition: .2s ease-in-out;
    border-radius: 10px;

    &:hover {
    //color: white;
    //background-color: rgba(25, 102, 179, 0.9);
    scale: 1.1;
    }

    @media (max-width: 1000px) {
        width: 100%;
        align-items: start;
        

        &:hover {
            scale: 1.1;
        }
    }
`

const ColumItemHeader = styled.div`
    display: flex;
    align-items: center;
    width: 230px;
    //border: solid 2px black;
`

const ColumItemHeaderIcon = styled.div`
    background-image: url(${props => props.iconImg});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    width: 25px;
    height: 25px;
    margin-right: 20px;
`
const ColumItemVisiblePasswordIcon = styled.div`
    background-image: url(${props => props.iconImg});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    width: 25px;
    height: 25px;
    margin-left: 20px;
    cursor: pointer;
`

const ColumItemHeaderName = styled.span`
    font-weight: bold;
`

const FieldAvaliableCheck = styled.div`
    background-image: url(${props => props.checkImg});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    width: 20px;
    height: 20px;
    margin-left: 20px;
`

const Input = styled.input`
    height: 30px;
    width: 230px;
    margin: 10px 0;
    border-radius: 0px;
    border: solid 0px rgba(0,0,0,.5);
    border-bottom: solid 1px rgba(0,0,0,.3);
    font-size: 16px;

    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer; 
     }

    @media (max-width: 1000px) {
    width: 100%;
    }

`
const ConfirmInput = styled.input`
    height: 40px;
    width: 300px;
    margin: 10px 0;
    border-radius: 5px;
    font-size: 16px;
    border: none;
    background-color: ${props => props.color};
    color: white;
    transition: .3s ease-in-out;
    text-align: center;
    pointer-events: ${props => props.available};
    &:hover {
    transform: translate(-2px, -2px);
    font-align: center;
    transition: .3s ease-in-out;

    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer; 
     }

    &:hover {
    scale: 1.1;
    filter: saturate(150%);
    }
    
    }
`
const ClearInput = styled.input`
    height: 40px;
    width: 230px;
    margin: 10px 0;
    border-radius: 5px;
    border: none;
    font-size: 16px;
    background-color: rgb(160, 28, 28);
    color: white;
    transition: .3s ease-in-out;
    opacity: 1;
    text-align: center;
    transition: .3s ease-in-out;

    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer; 
     }

    &:hover {
    scale: 1.1;
    filter: saturate(150%);
    }
`

const Select = styled.select`
    height: 35px;
    width: ${props => props.width};
    border-radius: 5px;
    border: none;
    border-bottom: solid 1px rgba(0,0,0,.3);
    margin: 10px 0;
    font-size: 16px;

    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer; 
     }

    @media (max-width: 1000px) {
    width: 100%;
    }
`

const ServerSelectContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 600px;
    //border: solid 2px black;
    margin-bottom: 30px;

    @media (max-width: 1000px) {
    width: 100%;
    }
    `

const ServerSelectHeader = styled.div`
    display: flex;
    align-items: center;
    width: 230px;
    margin: 50px 0 10px 0;
    //border: solid 2px black;

    @media (max-width: 1000px) {
    width: 100%;
    }
`

const ServerSelectIcon = styled.div`
    background-image: url(${props => props.iconImg});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    width: 25px;
    height: 25px;
    margin-right: 20px;

`

const ServerSelectName = styled.span`
    font-weight: bold;
    font-size: 24px;
`

const T1 = styled.span`
    margin: 20px 0;
    text-align: left;
`

const CheckBoxContainer = styled.div`
    width: 600px;
    //border: solid;
    display: flex;
    align-items: center;
    justify-content: start;
    margin: 30px 0;

    @media (max-width: 1000px) {
    width: 100%;
    }

`

const SpanRules = styled.span`
    @media (max-width: 1000px) {
    width: 100%;
    }
`

const InputRulesForm = styled.input`
    height: 30px;
    width: 50px;
    margin: 10px 0;
    border-radius: 0px;
    border: solid 0px rgba(0,0,0,.5);
    border-bottom: solid 1px rgba(0,0,0,.3);
    font-size: 16px;

    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer; 
     }
`
